<template>
  <span :title="isLoading"></span>
</template>
<script>
  import {pleaseWait} from "please-wait";
  import "please-wait/build/please-wait.css"
  import "spinkit/css/spinners/7-three-bounce.css"
  export default {
    data(){
      return {
        pleaseWaitInstance: null
      }
    },
    props: ['isLoading'],
    mounted () {
      this.updatePleaseWait()
    },
    beforeUpdate () {
      this.updatePleaseWait()
    },
    methods: {
      updatePleaseWait () {
        if (this.isLoading && this.pleaseWaitInstance == null) {
          this.pleaseWaitInstance = pleaseWait({
            logo: 'static/img/apps.svg',
            backgroundColor: '#fff',
            loadingHtml: '<div class="sk-spinner sk-spinner-three-bounce"><div class="sk-bounce1"></div><div class="sk-bounce2"></div><div class="sk-bounce3"></div></div>'
          })
        }
        if (!this.isLoading && this.pleaseWaitInstance != null) {
          this.pleaseWaitInstance.finish()
        }
      }
    }
  }
</script>
<!-- styling for the component -->
<style lang="scss">
  @import "./src/scss/loading";
</style>



// WEBPACK FOOTER //
// src/components/Loading.vue